import React from "react";
import Select, { components } from "react-select";
import Cookies from "js-cookie";

// Language data with emoji flags and names
const languageOptions = [
  { value: "en", label: "EN - English", shortLabel: "EN" },
  { value: "fr", label: "FR - Français", shortLabel: "FR" },
  { value: "nl", label: "NL - Nederlands", shortLabel: "NL" }, 
  { value: "de", label: "DE - Deutsch", shortLabel: "DE" },
];

// Customize how selected value looks → show only flag
const SingleValue = ({ data, ...props }) => (
  <components.SingleValue {...props}>
    <span style={{ fontSize: "15px", lineHeight: 1 }}>🌐 {data.shortLabel}</span>
  </components.SingleValue>
);

// Customize how dropdown options look → flag + name
const customGetOptionLabel = (e) => (
  <div style={{ display: "flex", alignItems: "center" }}>
    {/* <span style={{ marginRight: 8 }}>{e.flag}</span> */}
    <span>{e.label}</span>
  </div>
);

const getCustomStyles = (headerTransparent) => ({
  control: (provided) => ({
    ...provided,
    height: 38,
    minHeight: 38,
    backgroundColor: "transparent",
    boxShadow: "none",
    cursor: "pointer",
    ...(headerTransparent
      ? {
          borderColor: "#1466cc",
          "&:hover": {
            borderColor: "#1466cc",
          },
        }
      : {}),
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: 36,
    padding: "0 8px",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: 36,
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    ...(headerTransparent
      ? {
          color: "#1466cc",
          "&:hover": {
            color: "#1466cc",
          },
        }
      : {}),
  }),
  singleValue: (provided) => ({
    ...provided,
    margin: 0,
    ...(!headerTransparent ? { color: "#fff" } : {}),
  }),
  menu: (provided) => ({
    ...provided,
    width: 150,
  }),
  option: (provided) => ({
    ...provided,
    fontSize: "16px",
    padding: "10px",
  }),
  container: (provided) => ({
    ...provided,
    marginTop: 0,
  }),
});

const LanguageDropdown = ({ onChange, headerTransparent = false }) => {
const currentLang = localStorage.getItem("lang") || "en";
   
    let currentLanguageIndex = 0
    if (currentLang == 'en'){
      currentLanguageIndex = 0
    }
    else if (currentLang == 'fr') {
      currentLanguageIndex = 1
    }
    else if (currentLang == 'nl') {
      currentLanguageIndex = 2
    }
    else if (currentLang == 'de') {
      currentLanguageIndex = 3
    }
    else {
      currentLanguageIndex = 0
    }

  return (
    <Select
      options={languageOptions}
      defaultValue={languageOptions[currentLanguageIndex]}
      getOptionLabel={customGetOptionLabel}
      components={{
        SingleValue,
        // DropdownIndicator: () => null,
        // IndicatorSeparator: () => null,
      }}
      styles={getCustomStyles(headerTransparent)}
      isSearchable={false}
      onChange={onChange}
    />
  );
};

export default LanguageDropdown;
